import 'arrive';
import $ from 'jquery';

document.arrive('.top-footer', {existing: true}, function(){

  $('.has-arrow').on('click', function(){
    $(this).toggleClass('turn-arrow');
  })

});